<template>
<div>
  <Navbar />
  <div class="page-container">
    <router-view />
  </div>
</div>
</template>

<script>
import Navbar from '@main/components/Navbar.vue';
export default {
  components: {
    Navbar,
  },
};
</script>
<style>
.page-container {
  padding-top: 56px;
}
</style>
